import { Navigate, Route, Routes, resolvePath, useLocation } from 'react-router-dom';

import OfferPage from './offer';

export default function OffersPage() {
  const location = useLocation();

  return (
    <Routes>
      <Route path=":offer_id/*" element={<OfferPage />} />
      <Route path="*" element={<Navigate to={resolvePath('..', location.pathname)} />} />
    </Routes>
  );
}
